import { clamp } from "./numberHelpers";

const MAX_TIMEOUT_MS = 30000;

/**
 * Delay function calls until a set time elapses after the last invocation
 * @param {number} waitInMS Time to wait in milliseconds
 * @see https://www.joshwcomeau.com/snippets/javascript/debounce/
 *
 * @returns {(...args: any[]) => void} A debounced version of the input function
 */
export function debounce(func: (...args: unknown[]) => void, waitInMS: number): (...args: unknown[]) => void {
	let timeoutId: ReturnType<typeof setTimeout> | null = null;

	// Some browsers don't run the setTimeout if the wait time is negative
	// and we don't want to keep long running timeouts.
	const clampedWait = clamp(waitInMS, 0, MAX_TIMEOUT_MS);

	return (...args: unknown[]) => {
		const next = () => func(...args);

		if (timeoutId !== null) {
			clearTimeout(timeoutId);
		}

		timeoutId = setTimeout(next, clampedWait);
	};
}
